import { DateTimeRangeTypes } from '@/models/common/date-time-range-types.model';
import { useStatisticsListFilterStore, statisticsListFilterFormRef }
  from '@/store/statistics/statistics-list-filter.store';
import { getDateTimeRangeFormatted } from '@/utils/get-date-time-range.util';
import { storeToRefs } from 'pinia';
import { defineComponent, onMounted, ref } from 'vue';
import { useStatisticsListStore } from '@/store/statistics/statistics-list.store';
import { Refresh } from '@element-plus/icons-vue';
import { useEnvStore } from '@/store/env.store';
import { useDashboardStatisticsPeriodListStore } from '@/store/statistics/dashboard-statistics-period-list.store';
import { DateTimeFormatTypes } from '@/models/common/date-time-format-types.model';

const icons = {
  Refresh,
};

export default defineComponent({
  name: 'StatisticsListFilter',
  setup () {
    const { WL_SLUG } = storeToRefs(useEnvStore());

    const statisticsListFilterStore = useStatisticsListFilterStore();
    const {
      filterFormDateTimeRange,
      statisticsFilterFormData,
    } = storeToRefs(statisticsListFilterStore);
    const { setFilterFormData } = statisticsListFilterStore;

    const statisticsListStore = useStatisticsListStore();
    const { isStatisticsListLoading } = storeToRefs(statisticsListStore);
    const { getStatisticsList } = statisticsListStore;

    const dashboardStatisticsPeriodListStore = useDashboardStatisticsPeriodListStore();
    const { getDashboardStatisticsPeriodList } = dashboardStatisticsPeriodListStore;
    const {
      dashboardStatisticsPeriodList,
      isDashboardStatisticsPeriodListLoading,
    } = storeToRefs(dashboardStatisticsPeriodListStore);

    const selectedPeriod = ref<DateTimeRangeTypes>(DateTimeRangeTypes.TODAY);

    const handleStatisticsListFilterPeriodSelect = (period: DateTimeRangeTypes): void => {
      setFilterFormData(getDateTimeRangeFormatted(period, DateTimeFormatTypes.DATE_TIME_FULL));
    };

    const submitFilterAction = () => {
      if (!filterFormDateTimeRange.value) {
        return;
      }
      getStatisticsList(WL_SLUG.value, statisticsFilterFormData.value);
    };

    const clearDateRange = (): void => {
      setFilterFormData(getDateTimeRangeFormatted(DateTimeRangeTypes.TODAY, DateTimeFormatTypes.DATE_TIME_FULL));
    };

    onMounted(() => {
      getDashboardStatisticsPeriodList(WL_SLUG.value);
    });

    return {
      icons,
      statisticsListFilterFormRef,
      selectedPeriod,
      dashboardStatisticsPeriodList,
      handleStatisticsListFilterPeriodSelect,
      filterFormDateTimeRange,
      isStatisticsListLoading,
      isDashboardStatisticsPeriodListLoading,
      submitFilterAction,
      clearDateRange,
      DateTimeRangeTypes,
      DateTimeFormatTypes,
    };
  },
});
